// src/components/StatusMapping.js
// This file provides helper functions to map between log messages and Kanban status columns

// Define important log message patterns based on backend configuration
const LOG_PATTERNS = {
    NEW_LEAD: 'Created Quote',
    QUOTE_ONSITE: 'to "Quote : On Site Sales Consultation"',
    QUOTE_TRAVEL: 'to "Quote : Travelling to Site"',
    QUOTE_SENT: 'to "Quote : Sent to Client"',
    QUOTE_WON: 'to "Quote Won"',
    JOB_DEPOSIT: 'to "Job : Deposit Invoice Required"'
};

// Map log message to kanban column name
export const logMessageToKanbanStatus = (message) => {
    if (!message) return 'Office Quote'; // Default

    if (message.includes(LOG_PATTERNS.NEW_LEAD)) {
        return 'New Lead';
    } else if (message.includes(LOG_PATTERNS.QUOTE_ONSITE)) {
        return 'Quote On-Site';
    } else if (message.includes(LOG_PATTERNS.QUOTE_TRAVEL)) {
        return 'Quote Travel to Site';
    } else if (message.includes(LOG_PATTERNS.QUOTE_SENT)) {
        return 'Quote Sent';
    } else if (message.includes(LOG_PATTERNS.QUOTE_WON)) {
        return 'Quote Won';
    } else if (message.includes(LOG_PATTERNS.JOB_DEPOSIT)) {
        return 'Job - Invoice Deposit';
    }

    return 'Office Quote'; // Default for anything not matching
};

// Get kanban column for a quote based on its logs
export const determineQuoteStatus = (quoteLogs) => {
    if (!quoteLogs || quoteLogs.length === 0) {
        return 'New Lead';
    }

    // Sort logs by date (newest first)
    const sortedLogs = [...quoteLogs].sort((a, b) =>
        new Date(b.date_logged) - new Date(a.date_logged)
    );

    // Check each log message starting with the most recent
    for (const log of sortedLogs) {
        const message = log.message || '';

        // If it's a status change message, return the corresponding status
        if (
            message.includes(LOG_PATTERNS.NEW_LEAD) ||
            message.includes(LOG_PATTERNS.QUOTE_ONSITE) ||
            message.includes(LOG_PATTERNS.QUOTE_TRAVEL) ||
            message.includes(LOG_PATTERNS.QUOTE_SENT) ||
            message.includes(LOG_PATTERNS.QUOTE_WON) ||
            message.includes(LOG_PATTERNS.JOB_DEPOSIT)
        ) {
            return logMessageToKanbanStatus(message);
        }
    }

    // If no status change logs found, look for creation messages
    const creationLog = sortedLogs.find(log =>
        log.message && log.message.toLowerCase().includes('created')
    );

    if (creationLog) {
        return 'New Lead';
    }

    // Default fallback
    return 'Office Quote';
};

// Get the formatted message for a status change
export const getStatusChangeMessage = (kanbanStatus) => {
    switch (kanbanStatus) {
        case 'New Lead':
            return LOG_PATTERNS.NEW_LEAD;
        case 'Quote On-Site':
            return LOG_PATTERNS.QUOTE_ONSITE;
        case 'Quote Travel to Site':
            return LOG_PATTERNS.QUOTE_TRAVEL;
        case 'Quote Sent':
            return LOG_PATTERNS.QUOTE_SENT;
        case 'Quote Won':
            return LOG_PATTERNS.QUOTE_WON;
        case 'Job - Invoice Deposit':
            return LOG_PATTERNS.JOB_DEPOSIT;
        default:
            return `Status changed to ${kanbanStatus}`;
    }
};